import React, { Component } from 'react';
import classes from "./TextZodiac1.module.css";

export default class TextPersonSpecies extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>
                
                <p className="text-anal">The fascination with magic, myth, astrology, and the zodiac is as old as time. What is a game without the Zodiac and Constellatons? What is Animal Crossing without it's Zodiac Furniture Collection? One of the best aspects of collecting a Libra Scale (or any other Zodiac Furniture piece) is that the DIY recipe to make these Zodiac collectibles requires the player to find a Zodiac [Star] Fragment, in this case a Libra Star Fragment. Because collecting Libra fragments can only be done in the month of the Libra, this adds to the urgency of the game play, making it fun with a must-login feel.</p>
        
                <p className="text-anal">To create the Libra Scale, it requires 2 Zodiac/Libra fragment, 3 Star Fragments, 0 Stones, and 2 Gold pieces. I must note that I especially enjoyed creating a Radar Polar chart because of its "star-like" design.</p> 

                <p className="text-anal">Analysis: Looking at all four charts, each furniture piece requires 2 pieces of each Zodiac fragment (e.g. Libra Scale requires 2 Libra fragments, Virgo Harp requires 2 Virgo fragments, etc.) Additionally, two items (Libra Scale and Saggitarius Arrow) do not require any Stone while the Capricorn Ornament requires many (12!) Stones. The Earth Zodiac Signs (Taurus, Virgo, Capricorn) uses the most diverse number (from 2 Gold to 12 Stones) of materials.</p>
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/